var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0005 1.93433L21.0005 7.13048V17.5228L12.0005 22.7189L3.00049 17.5228V7.13048L12.0005 1.93433ZM9.00044 11.6336L9.00049 18.6776L11.0005 19.8323V12.7883L9.00044 11.6336ZM5.00049 9.32433V16.3681L7.00047 17.5228V10.479L5.00049 9.32433ZM15.9376 6.51678L10.0511 9.93097L12.0005 11.0565L17.9005 7.65009L15.9376 6.51678ZM12.0005 4.24373L6.10049 7.65009L8.05338 8.77756L13.9399 5.36342L12.0005 4.24373Z",
    fill: "#5D2EDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductSvgrepoCom1);
export default __webpack_public_path__ + "static/media/product-svgrepo-com 1.69890ae8c98f09288194957d5c489a61.svg";
export { ForwardRef as ReactComponent };